module.exports = __webpack_public_path__ + "img/step_test_splash.b51a2641.jpg";